export type StoreBackend = {
	get: (name: string) => string | null | undefined;
	put: (name: string, value: string | null | undefined) => boolean;
	remove: (name: string) => boolean;
};
type WindowStorage = {
	getItem: (arg0: string) => any;
	setItem: (arg0: string, arg1: any) => void;
	removeItem: (arg0: string) => void;
};

/**
 * A PerTabStorage stores data per browser tab.
 * Multiple tabs for the same url do NOT share the state.
 */
export function createStorage(windowStorage: WindowStorage | null | undefined, storageName: string): StoreBackend {
	const store: Record<string, any> = {};

	const _get = function (key: string): any {
		const value = windowStorage && windowStorage.getItem(key);

		if (value !== undefined && value !== null) {
			return value;
		} else {
			return store[key];
		}
	};

	const _put = function (key: string, value: string | null | undefined): boolean {
		if (windowStorage) {
			try {
				windowStorage.setItem(key, value);
				// For debugging purposes and to enable a storage reset for a specific time.
				// However, in this current implementation, these timestamps will have no GDPR category
				// and are thus not readable via GdprStorage.
				windowStorage.setItem(key + "_timestamp", Date.now());
				return true;
			} catch {
				console.error("putting " + key + " into " + storageName + " failed");
				windowStorage.removeItem(key);
				return false;
			}
		} else {
			console.error("putting " + key + " into " + storageName + " failed beacuse windowStorage is empty");
		}

		store[key] = value;
		return true;
	};

	const _remove = function (key: string): boolean {
		if (windowStorage) {
			windowStorage.removeItem(key);
		}

		store[key] = undefined;
		return true;
	};

	const result: StoreBackend = {
		get: _get,
		put: _put,
		remove: _remove,
	};
	return result;
}
export const PerTabStorage = createStorage(window.sessionStorage, "sessionStorage") as StoreBackend;
export const PerSessionStorage = createStorage(window.localStorage, "localStorage") as StoreBackend;
// For Testing:
export const PurStorage = createStorage;
